import { Button } from '@merels/ui'

export interface AddBotButtonProps {
  onClick: () => void
  'data-testid'?: string
}

/**
 * AddBotButton renders the bottom-of-panel "Add Bot" call to action.
 *
 * In 2-player test/local-test color mode we tint the border + text to match the current player
 * (same visual language as other test-mode controls).
 */
export function AddBotButton({
  onClick,
  ...rest
}: AddBotButtonProps) {

  return (
    <div className={"px-2 py-2"}>
      <Button
        onClick={onClick}
        variant="outline"
        size="sm"
        className={"w-full text-xs bg-transparent hover:bg-subtle"}
        {...rest}
      >
        Add Bot
      </Button>
    </div>
  )
}
